(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User','UserAccount'];

    function UserManagementDetailController ($stateParams, User,UserAccount) {
        var vm = this;

        vm.load = load;
        vm.user = {};
       
        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
       UserAccount.get(function (data) {
                data.authorities.forEach(function (val) {
                    if(val == "ROLE_READONLY"){
                         vm.has_ROLE_READONLY=true
                    }
                });
            });
    }
})();
